import {
  BaseQueryFn,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { navigate } from "gatsby";
import { toast } from "react-toastify";

import routes from "../../constants/routes";
import { BACKEND_URL } from "../../constants/settings";
import { UserActions } from "../features/user";
import { RootState } from "../store";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: BACKEND_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).user.authToken;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<
  Parameters<typeof rawBaseQuery>[0],
  unknown,
  unknown
> = async (args, api, extraOptions) => {
  // run the actual request
  const result = await rawBaseQuery(args, api, extraOptions);

  // handle errors
  if (result.error) {
    if (result.error.status === 401) {
      api.dispatch(UserActions.clearAuthToken());
      navigate(routes.home);
    } else {
      toast.error("Something went wrong");
      console.log(result.error);
    }
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Users", "Images"],
  endpoints: () => ({}),
});
